import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bookingData: {
    bookingID: null,
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    price_per_night: null,
    total_amount: null,
    security_deposit: null, 
    pickup_cost: null,
    pickup_location: "",
    grand_total: null,
    guests: "",
    checkIn: null,
    checkOut: null,
    numberOfNights: null, 
    stayDates: "",
    idVerified: false,
    id_document_name: null,
   id_document_preview: null, 
  },
};

function calculateNights(checkIn, checkOut) {
  if (checkIn && checkOut) {
    const inDate = new Date(checkIn);
    const outDate = new Date(checkOut);
    return Math.ceil((outDate - inDate) / (1000 * 60 * 60 * 24));
  }
  return null;
}

function formatFullDate(dateStr) {
  return dateStr
    ? new Date(dateStr).toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : "";
}

function calculateSecurityDeposit(price_per_night) {
  return price_per_night >= 300000 ? 200000 : 100000;
}

const StaySmallSmallBookingData = createSlice({
  name: "staySmallSmallBookingData",
  initialState,
  reducers: {
    setBookingData(state, action) {
      const { checkIn, checkOut, price_per_night, id_document_name, id_document_preview, ...rest } = action.payload;
      const actualCheckIn = checkIn ?? state.bookingData.checkIn;
      const actualCheckOut = checkOut ?? state.bookingData.checkOut;
      const actualPricePerNight = price_per_night ?? state.bookingData.price_per_night;
      state.bookingData = {
        ...state.bookingData,
        ...rest,
        id_document_name:  state.bookingData.id_document_name,
       id_document_preview: state.bookingData.id_document_preview,
        checkIn: actualCheckIn,
        checkOut: actualCheckOut,
        price_per_night: actualPricePerNight,
        security_deposit: actualPricePerNight != null ? calculateSecurityDeposit(actualPricePerNight) : state.bookingData.security_deposit,
        numberOfNights: calculateNights(actualCheckIn, actualCheckOut),
        stayDates:
          actualCheckIn && actualCheckOut
            ? `${formatFullDate(actualCheckIn)} - ${formatFullDate(actualCheckOut)}`
            : "",
      };
    },
     setIdVerified(state, action) {
      state.bookingData.idVerified = !!action.payload;
    },
    clearBookingData(state) {
      state.bookingData = { ...initialState.bookingData };
    },
  },
});

export const { setBookingData, clearBookingData, setIdVerified } = StaySmallSmallBookingData.actions;

export default StaySmallSmallBookingData.reducer;